import script from "./ReminderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NumberStepper from "@/components/neue/wizard/NumberStepper.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import WizardIcon from "@/components/neue/wizard/WizardIcon.vue";
script.components = Object.assign({}, { NumberStepper, SelectInput, WizardIcon }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NumberStepper, SelectInput, WizardIcon }, script.__o.components);}